module.exports = __webpack_public_path__ + "static/media/microsoft_logo1.6d1ccdcc.png";